import dayjs from 'dayjs';

import { CoachesBooking, CoachesBookingServer } from '../store/types';

const initCoachBookingRow = (columns: CoachesBookingServer[number]['columns'], startTime: string) => ({
  startTime,
  columns: columns.map((column) => ({
    coachId: column.coach_id,
    coachName: column.coach_name,
    bookingId: null,
    userName: null,
    courtName: null,
    isBookingEnd: false,
    isBookingStart: false
  }))
});

export const adaptCoachesBooking = (res: CoachesBookingServer): CoachesBooking => {
  const coachesBooking: CoachesBooking = [{
    startTime: res[0].start_time, columns: res[0].columns.map((column) => ({
      coachId: column.coach_id,
      coachName: column.coach_name,
      bookingId: null,
      userName: null,
      courtName: null,
      isBookingEnd: false,
      isBookingStart: false
    }))
  }];

  res.forEach((row, index) => {
    const nextRowTime = dayjs(row.start_time).add(30, 'minutes').format('YYYY-MM-DDTHH:mm:ss');
    const nextColumns = res[index + 1]?.columns ?? res[index].columns;
    const prevColumns = res[index - 1]?.columns;
    coachesBooking[index + 1] = initCoachBookingRow(res[index].columns, nextRowTime);
    row.columns.forEach((column, columnIndex) => {
      coachesBooking[index].columns[columnIndex] = {
        coachId: column.coach_id,
        coachName: column.coach_name,
        bookingId: column.booking_id,
        userName: column.user_name,
        courtName: column.court_name,
        isBookingEnd: column.booking_id !== nextColumns[columnIndex].booking_id,
        isBookingStart: prevColumns !== undefined
          ? column.booking_id !== prevColumns[columnIndex].booking_id
          : true
      };
    });
  });

  coachesBooking.unshift({
    startTime: dayjs().set('hour', 0).format('YYYY-MM-DDTHH:mm:ss'),
    columns: res[0].columns.map((column) => ({
      coachId: column.coach_id,
      coachName: column.coach_name,
      bookingId: null,
      userName: null,
      courtName: null,
      isBookingEnd: false,
      isBookingStart: false
    }))
  });

  return (coachesBooking);
};
